import React from 'react';
import classnames from 'classnames';

import { scores } from 'constants/score';

interface Props {
  scoreId?: string;
  id?: string;
  scoreValue?: number | null;
  handleChange: (name: string, value: number | null) => void;
  name: string;
  disabled?: boolean;
  lightMode?: boolean;
}

const ScoreTab: React.FC<Props> = (props) => {
  const { scoreId, id, scoreValue, handleChange, name, disabled, lightMode } = props;

  // Fallback chain: scoreId (primary) -> id (backwards compat) -> name
  const baseId = scoreId ?? id ?? name;

  const handleClick = (score: number, isSelected: boolean) => {
    const value = isSelected ? null : score;
    handleChange(name, value);
  };

  const options = scores.map((score) => {
    const isSelected = !!scoreValue && scoreValue === score;

    const buttonContainerClass = classnames(`${lightMode ? 'light-' : ''}box-links__nodes`, {
      [`${lightMode ? 'light-' : ''}box-links__nodes--active`]: isSelected,
      [`${lightMode ? 'light-' : ''}box-links__nodes--disabled`]: disabled,
    });

    const labelClass = classnames('score-tab__value', {
      'score-tab__value--disabled': disabled,
    });

    return (
      <div className={buttonContainerClass} key={score}>
        <label htmlFor={`${baseId}-${score}`} className={labelClass}>
          <input
            type="radio"
            id={`${baseId}-${score}`}
            name={name}
            onClick={() => handleClick(score, isSelected)}
            className="score-tab__radio"
            disabled={disabled}
          />
          {score}
        </label>
      </div>
    );
  });

  return <div className="box-links">{options}</div>;
};

export default ScoreTab;
